module.exports = __webpack_public_path__ + "img/user.16069ca8.svg";